import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Componente ScrollToTop para usar en JSX y escuchar cambios de rutas
export default function ScrollToTop({ low = 'auto' }: { low?: ScrollBehavior }) {
  const { pathname } = useLocation();
  const scrollBehavior: ScrollBehavior = ['auto', 'smooth'].includes(low) ? low : 'auto';

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: scrollBehavior });
  }, [pathname, scrollBehavior]);

  return null; // El componente no renderiza nada
}

// Programática para hacer scroll a la parte superior
export function scrollToTop(low: ScrollBehavior = 'auto') {
  const scrollBehavior: ScrollBehavior = ['auto', 'smooth'].includes(low) ? low : 'auto';
  window.scrollTo({ top: 0, behavior: scrollBehavior });
}
